import type { MessageKey } from "./ru"

export const koMessages = {
  "common.loading": "불러오는 중...",
  "common.error": "오류",
  "common.back": "뒤로",
  "common.next": "다음",
  "common.search": "검색",
  "auth.loginErrorTitle": "로그인 오류",
  "auth.openViaTelegram": "Telegram에서 앱을 열어 주세요",
  "auth.telegramRequired": "앱은 Telegram을 통해 열어야 합니다",
  "auth.authorizationError": "인증 오류",
  "device.rotatePortrait": "기기를 세로 모드로 돌려 주세요",
  "country.brazil": "브라질",
  "country.vietnam": "베트남",
  "country.egypt": "이집트",
  "country.india": "인도",
  "country.indonesia": "인도네시아",
  "country.iran": "이란",
  "country.spain": "스페인",
  "country.italy": "이탈리아",
  "country.kazakhstan": "카자흐스탄",
  "country.colombia": "콜롬비아",
  "country.malaysia": "말레이시아",
  "country.mexico": "멕시코",
  "country.nigeria": "나이지리아",
  "country.pakistan": "파키스탄",
  "country.russia": "러시아",
  "country.usa": "미국",
  "country.turkey": "튀르키예",
  "country.uzbekistan": "우즈베키스탄",
  "country.ukraine": "우크라이나",
  "country.philippines": "필리핀",
  "countrySelection.chooseCountry": "국가 선택",
  "countrySelection.openAria": "국가 선택",
  "languageSelection.chooseLanguage": "언어 선택",
  "commercial.direction.autotrade": "자동차 마켓",
  "commercial.direction.insurance": "보험",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "긴급출동",
  "commercial.searchLabel": "BeepApp 검색",
  "commercial.cityPlaceholder": "도시 입력",
  "commercial.emptyTitle": "오늘은 제안이 없습니다",
  "commercial.emptyLine1": "아직 이 도시에 활성 BeepApp 파트너가 없습니다",
  "commercial.emptyLine2": "파트너를 찾고 연결하는 작업을 진행 중입니다",
  "commercial.emptyLine3": "새로운 제안은 여기에 자동으로 표시됩니다",
  "commercial.helperLine1": "도시를 입력하여",
  "commercial.helperLine2": "이용 가능한 제안을 확인하세요",
  "commercial.partnerPrompt": "BeepApp 파트너가 되시겠습니까?",
  "commercial.apply": "신청",
  "main.admin": "관리자",
  "main.garage": "차고",
  "main.signalSent": "신호를 보냈습니다",
  "main.partnerInviteUnavailable": "파트너 초대를 사용할 수 없습니다",
  "main.enterPlate": "차량 번호 입력",
  "main.searchError": "검색 오류",
  "main.signalSendError": "신호를 보내지 못했습니다",
  "main.shareCardPrefix": "번호판 카드",
  "main.shareLinkError": "링크를 만들지 못했습니다",
  "main.searchByPlateAria": "번호판으로 검색",
  "main.russianPlateAria": "러시아 번호판",
  "main.plateAria": "번호판",
  "main.findPlateAria": "번호판 찾기",
  "main.loadingVehicle": "차량 카드를 불러오는 중…",
  "main.leaveSignal": "신호 보내기",
  "main.share": "공유",
  "signalSelection.chooseType": "신호 유형 선택",
  "signalSelection.category.attention": "개인",
  "signalSelection.category.road": "도로",
  "signalSelection.category.urgent": "긴급",
  "signalSelection.chooseSignal": "신호 선택",
  "signalSelection.suggestOwn": "직접 제안하기",
  "signalConfirmation.title": "신호 확인",
  "signalConfirmation.plateHeading": "번호판을 확인하세요",
  "signalConfirmation.signalHeading": "선택한 신호를 확인하세요",
  "signalConfirmation.replyTitle": "Telegram 답장 허용",
  "signalConfirmation.replyBody": "이 옵션을 켜면 번호판 소유자가 Telegram에서\n메시지를 보낼 수 있습니다. 답장은 @username이\n있는 경우에만 가능합니다. 답장 여부는\n번호판 소유자가 결정합니다.",
  "signalConfirmation.consentText": "이 신호가 실제 상황을 반영하며\n스팸이나 허위 신고가 아님을\n확인합니다.",
  "signalConfirmation.warning": "전송 후에는 신호를\n변경할 수 없습니다",
  "signalConfirmation.sending": "전송 중…",
  "signalConfirmation.send": "보내기",
  "partner.loadingAria": "불러오는 중",
  "partner.title": "파트너 프로그램",
  "partner.offerLine1": "초대한 사용자의 모든 결제에서 30%를 계속 받으세요",
  "partner.offerLine2": "BeepApp에 초대한 사용자의 결제가 대상입니다",
  "partner.offerLine3": "Telegram 제휴 프로그램을 통해 지급됩니다",
  "partner.connectUnavailable": "Telegram 제휴 프로그램 설정 후 연결할 수 있습니다.",
  "partner.connectTelegram": "Telegram에서 연결",
  "partner.qrAria": "파트너 링크 QR 코드",
  "partner.download": "다운로드",
  "partner.promoHeading": "개인 프로모 코드 만들기",
  "partner.promoHelperLine1": "프로모 코드는 추가 구독 1년을 활성화합니다",
  "partner.promoHelperLine2": "사용자 유치에도 도움이 됩니다",
  "partner.promoAria": "프로모 코드",
  "partner.affiliateHeading": "내 제휴 링크",
  "partner.affiliateHelper": "개인 QR 코드를 만들려면 링크를 저장하세요",
  "partner.affiliateAria": "제휴 링크",
  "partner.qrNoteLine1": "QR 코드는 차량과",
  "partner.qrNoteLine2": "소셜 미디어 및 광고 자료에 사용할 수 있습니다",
  "partner.save": "저장",
  "partner.reset": "초기화",
  "partner.resetConfirm": "저장된 제휴 링크를 초기화할까요? 프로모 코드는 유지됩니다.",
  "partner.promoFormatError": "프로모 코드는 4~15자여야 합니다.",
  "partner.affiliateHostError": "t.me 또는 telegram.me 링크만 허용됩니다.",
  "partner.affiliatePathError": "링크에 Telegram 경로가 없습니다.",
  "partner.affiliateFormatError": "유효하지 않은 제휴 링크입니다.",
  "partner.loadError": "불러오기 오류",
  "partner.checkInputError": "입력한 정보를 확인하세요",
  "garageActivation.promoInvalid": "프로모 코드가 유효하지 않습니다",
  "garageActivation.plateOccupied": "이 번호판은 이미 연결되어 있습니다",
  "garageActivation.activateError": "차고를 활성화하지 못했습니다",
  "garageEntry.loadJournalError": "운행 기록을 불러오지 못했습니다",
  "garageEntry.loadStatusesError": "상태를 불러오지 못했습니다",
  "garageEntry.activationSuccess": "차고가 활성화되었습니다",
  "garageEntry.plateAttached": "번호판이 연결되었습니다",
  "garageEntry.attachError": "번호판을 연결하지 못했습니다",
  "garageEntry.activationNote": "차고를 활성화하세요",
  "garageSheet.activationTitle": "차고 활성화",
  "garageSheet.plateHelper": "차량 번호판을 입력하세요",
  "garageSheet.promoHelper": "프로모 코드가 있나요?",
  "garageSheet.cleanBonusLine1": "활성화 후 1시간 동안",
  "garageSheet.cleanBonusLine2": "무료 ‘Clean Start’를 사용할 수 있습니다",
  "garageSheet.activationFor": "활성화 기간",
  "garageSheet.cost": "비용",
  "garageSheet.ownerConsentLine1": "입력한 번호판이 부착된",
  "garageSheet.ownerConsentLine2": "차량의 소유자임을",
  "garageSheet.ownerConsentLine3": "확인합니다.",
  "garageSheet.processing": "처리 중...",
  "garageSheet.attach": "연결",
  "garageSheet.pay": "결제",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "차고 비활성화",
  "garageLifecycle.cleanWarningLine1": "번호판 기록이 삭제되며",
  "garageLifecycle.cleanWarningLine2": "복구할 수 없습니다!",
  "garageLifecycle.deactivateWarningLine1": "비활성화 후 활성 차고",
  "garageLifecycle.deactivateWarningLine2": "기능을 이용할 수 없습니다",
  "garageLifecycle.willBeDeleted": "삭제됩니다",
  "garageLifecycle.cleanRemovedLine1": "• 운행 기록의 모든 항목",
  "garageLifecycle.cleanRemovedLine2": "• 수신 신호 기록",
  "garageLifecycle.cleanRemovedLine3": "• 공개 신호 카운터",
  "garageLifecycle.cleanRemovedLine4": "  번호판 카드의 표시",
  "garageLifecycle.willRemain": "유지됩니다",
  "garageLifecycle.cleanPreservedLine1": "• 번호판과 차고의 연결",
  "garageLifecycle.cleanPreservedLine2": "• 남은 활성화 기간",
  "garageLifecycle.cleanPreservedLine3": "• 선택한 번호판 상태",
  "garageLifecycle.cleanPreservedLine4": "• 번호판 카드 총 조회수",
  "garageLifecycle.freeFirstHour": "첫 1시간 무료",
  "garageLifecycle.willBecomeUnavailable": "사용할 수 없게 됩니다",
  "garageLifecycle.deactivateRemovedLine1": "• 운행 기록",
  "garageLifecycle.deactivateRemovedLine2": "• 번호판 상태 선택 및 사용",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClan에서 자동 탈퇴",
  "garageLifecycle.deactivateRemovedLine4": "• 자동차 마켓",
  "garageLifecycle.deactivateRemovedLine5": "• 보험",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• 긴급출동",
  "garageLifecycle.deactivateRemovedLine8": "• 번호판과 차고 연결 해제",
  "garageLifecycle.willRemainAvailable": "계속 이용할 수 있습니다",
  "garageLifecycle.deactivatePreservedLine1": "• 동행",
  "garageLifecycle.deactivatePreservedLine2": "• 디스패처",
  "garageLifecycle.deactivatePreservedLine3": "• 번호판 검색 및 조회",
  "garageLifecycle.deactivatePreservedLine4": "  공개 차량 카드",
  "garageLifecycle.deactivatePreservedLine5": "• 언제든 차고를",
  "garageLifecycle.deactivatePreservedLine6": "  다시 활성화할 수 있습니다",
  "garageLifecycle.cleanConsentLine1": "이 번호판의 전체 기록을",
  "garageLifecycle.cleanConsentLine2": "복구할 수 없도록 삭제하는 데",
  "garageLifecycle.cleanConsentLine3": "동의합니다.",
  "garageLifecycle.deactivateConsentLine1": "비활성화와 함께 모든",
  "garageLifecycle.deactivateConsentLine2": "활성 차고 기능에 대한 접근을",
  "garageLifecycle.deactivateConsentLine3": "종료하는 데 동의합니다.",
  "garageLifecycle.clean": "삭제",
  "garageLifecycle.deactivate": "비활성화",
} satisfies Record<MessageKey, string>
